import ResponsiveSidebar from "../../General/ResponsiveSidebar/ResponsiveSidebar";
import React from "react";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  PeopleAlt as PeopleAltIcon,
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
  EventAvailable as EventAvailableIcon,
} from "@mui/icons-material";
import { Link as RouterLink, useLocation } from "react-router-dom";

const drawerWidth = 240;
const collapsedWidth = 60;

interface SidebarProps {
  open?: boolean;
  toggle?: () => void;
}

const HireSidebar = ({ open = false, toggle = () => {} }: SidebarProps) => {
  const location = useLocation();

  const menuItems = [
    { text: "Candidates", icon: <PeopleAltIcon />, path: "/hire-crm" },
    {
      text: "Scheduled Candidates",
      icon: <EventAvailableIcon />,
      path: "/hire-crm/scheduled",
    },
    { text: "External Form", icon: <PeopleAltIcon />, path: "/candidate" },
  ];

  const isSelected = (path: string) => location.pathname.startsWith(path);

  return (
    <>
      <ResponsiveSidebar
        open={open}
        onClose={toggle}
        sx={(theme) => ({
          width: open ? drawerWidth : collapsedWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: open ? drawerWidth : collapsedWidth,
            boxSizing: "border-box",
            top: 64,
            height: "calc(100% - 64px)",
            overflowX: "hidden",
            position: "fixed",
            transition: theme.transitions.create("width", {
              duration: theme.transitions.duration.standard,
            }),
          },
        })}
      >
        <Toolbar sx={{ justifyContent: open ? "flex-end" : "center" }}>
          <IconButton
            onClick={toggle}
            aria-label={
              open ? "Close section navigation" : "Open section navigation"
            }
          >
            {open ? <ChevronLeftIcon /> : <MenuIcon />}
          </IconButton>
        </Toolbar>
        <List>
          {menuItems.map((item) => {
            const button = (
              <ListItemButton
                key={item.text}
                selected={isSelected(item.path)}
                component={RouterLink}
                to={item.path}
                sx={{ justifyContent: open ? "initial" : "center" }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 0,
                    justifyContent: "center",
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.text}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            );
            return open ? (
              button
            ) : (
              <Tooltip key={item.text} title={item.text} placement="right">
                {button}
              </Tooltip>
            );
          })}
        </List>
      </ResponsiveSidebar>
    </>
  );
};

export default HireSidebar;
